import { Component, Host, Inject, Input, Optional } from '@angular/core';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { menuItemStylesSAG, menuItemStylesSHS } from './menu-item.styles';
import { MenuTriggerDirective } from '../menu-trigger.directive';

@Component({
  selector: 'sag-ui-menu-item',
  template: `
    <div
      [class]="styles"
      (click)="handleClick($event)"
      (mouseenter)="handleMouseEnter($event)"
    >
      <ng-content></ng-content>
      @if (trigger) {
        <span class="icon-chevron-right"></span>
      }
    </div>
  `,
})
export class MenuItemComponent {
  @Input() class = '';
  @Input() click: (e: Event) => void = () => {};
  @Input() mouseenter: (e: Event) => void = () => {};

  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    @Optional() @Host() public trigger: MenuTriggerDirective,
  ) {}

  protected handleClick(event: Event): void {
    if (this.trigger) return;
    this.click(event);
  }

  protected handleMouseEnter(event: Event): void {
    if (this.trigger) return;
    this.mouseenter(event);
  }

  protected get styles() {
    return (
      componentStylesByTheme(
        this.theme,
        menuItemStylesSAG,
        menuItemStylesSHS,
      )() + (this.class ? ` ${this.class}` : '')
    );
  }
}
